module.exports = __webpack_public_path__ + "img/tuceng1121.33804c32.png";